import React, { useContext } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { Box, Button, IconButton, Link, Typography } from '@mui/material'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
import { ContextoGlobal, ContextoGlobalInterface } from '../GlobalStates/ContextoGlobal'
import { EMDESENVOLVIMENTO } from '../ImportBackend/Config/emDesenvolvimento'

import { styled } from '@mui/material/styles';
import Condicional from './Condicional'
import NavegacaoInferior from './NavegacaoInferior'

export default function BottomBar () {

  const Offset = styled( 'div' )( ( { theme } ) => theme.mixins.toolbar );

  const contexto: ContextoGlobalInterface = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const [isFullscreen, setIsFullscreen] = React.useState<boolean>( false )

  const btFullscreen = () => {

    if ( !document.fullscreenElement &&    // standard
      //@ts-ignore
      !document.mozFullScreenElement && // Firefox
      //@ts-ignore
      !document.webkitFullscreenElement && // Chrome, Safari and Opera
      //@ts-ignore
      !document.msFullscreenElement ) {  // IE/Edge

      if ( document.documentElement.requestFullscreen ) {
        document.documentElement.requestFullscreen();
        //@ts-ignore
      } else if ( document.documentElement.webkitRequestFullscreen ) { /* Safari */
        //@ts-ignore
        document.documentElement.webkitRequestFullscreen();
        //@ts-ignore
      } else if ( document.documentElement.msRequestFullscreen ) { /* IE11 */
        //@ts-ignore
        document.documentElement.msRequestFullscreen();
      }

      setIsFullscreen( true )

    } else {

      if ( document.exitFullscreen ) {
        document.exitFullscreen();
        //@ts-ignore
      } else if ( document.webkitExitFullscreen ) { /* Safari */
        //@ts-ignore
        document.webkitExitFullscreen();
        //@ts-ignore
      } else if ( document.msExitFullscreen ) { /* IE11 */
        //@ts-ignore
        document.msExitFullscreen();
      }
      setIsFullscreen( false )

    }
  }

  return (
    <>
      <Offset />

      <AppBar sx={{ top: 'auto', bottom: 0, maxHeight: '40px' }}>
        <Toolbar>

          <Box sx={{ flexGrow: 1 }} >
            <NavegacaoInferior></NavegacaoInferior>

            <Condicional condicao={EMDESENVOLVIMENTO}>
              <Typography variant="body2" component="div" sx={{ marginBottom: 2 }}>
                {contexto.loginState.token}
              </Typography>
            </Condicional>

            <Condicional condicao={!EMDESENVOLVIMENTO}>

              <Typography variant="body2" component="div" sx={{ marginBottom: 2, textAlign: 'left' }}>
                {'Copyright © '}
                <Link color="inherit" href={process.env.REACT_APP_URL_CLIENTE}>
                  {process.env.REACT_APP_NOME_CLIENTE}
                </Link>
                {' '}
                {new Date().getFullYear()}
                {'.'}
              </Typography>

            </Condicional>
          </Box>

          <Box sx={{ flexGrow: 0, textAlign: 'right' }} >
            <Condicional condicao={contexto.loginState.logado}>
              <Typography variant="body2" component="div" sx={{ mb: 2.5, textAlign: 'right' }}>
                {contexto.loginState.nome.split( ' ' )[0]}
              </Typography>
            </Condicional>
          </Box>

          <Box sx={{ flexGrow: 0, textAlign: 'right' }} >
            <IconButton onClick={() => btFullscreen()}
            >
              {isFullscreen ? <FullscreenExitIcon sx={{ mb: 2.5, mr: 0, color: 'white' }} /> :
                <FullscreenIcon sx={{ mb: 2.5, mr: 0, color: 'white' }} />}
            </IconButton>
          </Box>

        </Toolbar>

      </AppBar>
    </>
  )
}